export const DEFAULT_CLIENT_ID =
  '40b3a00e282ee2db1338c3bba881b99125fc3ba1d7f5c29232ce1ad63fab1e75';
